/** Signal-based global toast queue. Call `toast.success('…')` etc. from anywhere; render `<ToastHost>` once (already mounted in AppShell). */
import { signal } from '@preact/signals';

export type ToastKind = 'info' | 'success' | 'warn' | 'error';

export interface ToastItem {
  id: string;
  kind: ToastKind;
  message: string;
  duration: number;
}

export const toasts = signal<ToastItem[]>([]);

let counter = 0;

function push(kind: ToastKind, message: string, duration = 4000): string {
  const id = `toast-${Date.now()}-${counter++}`;
  toasts.value = [...toasts.value, { id, kind, message, duration }];
  if (duration > 0) {
    setTimeout(() => dismiss(id), duration);
  }
  return id;
}

export function dismiss(id: string): void {
  toasts.value = toasts.value.filter((t) => t.id !== id);
}

export const toast = {
  info: (message: string, duration?: number) => push('info', message, duration),
  success: (message: string, duration?: number) => push('success', message, duration),
  warn: (message: string, duration?: number) => push('warn', message, duration),
  error: (message: string, duration?: number) => push('error', message, duration),
  dismiss,
};
